import { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useUserType } from '../hooks/useUserType';
import LoadingPage from './LoadingPage';

interface AdminRouteProps {
    children: ReactNode;
    /**
     * Where non-admins are redirected. Defaults to `/signer` — the signer's
     * home page, which is the right target for admin-only feature subtrees
     * (Policies, Users, Calendar, etc.).
     *
     * For the workspace-settings subtree (`/settings/*`, issue #2114) we pass
     * `/account/profile` so signers who deep-link into Billing/Digest/SSO land
     * on their own personal settings rather than being bounced all the way
     * back to `/signer`.
     */
    redirectTo?: string;
}

function AdminRoute({ children, redirectTo = '/signer' }: AdminRouteProps) {
    const { isAdmin, loading } = useUserType();

    if (loading) {
        return <LoadingPage />;
    }

    if (!isAdmin) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
}

export default AdminRoute;
